// extracted by mini-css-extract-plugin
module.exports = {"container":"Quote-module--container--35HDe","svg":"Quote-module--svg--3sHzc","title":"Quote-module--title--zhYkY"};